import { track } from "../services/analytics";
import LeadComposer from "./LeadComposer";

const ICON = {
  phone:
    "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z",
  calendar:
    "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
  note: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
};

const Icon = ({ d }) => (
  <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={d} />
  </svg>
);

const BUTTON =
  "inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium border border-border text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-colors";

/**
 * Full lead page: the composer plus Call, Book and Add note. The sidecart uses
 * the Conversation card instead.
 */
const LeadActRow = ({ authToken, lead, onSent, onBook, onAddNote }) => {
  const hasPhone = !!lead.phone;

  return (
    <div className="rounded-md border border-border bg-white px-4 py-3">
      <LeadComposer authToken={authToken} lead={lead} onSent={onSent} />

      <div className="mt-2 flex flex-wrap items-center gap-2">
        <a
          data-attr="quick-action-call"
          href={hasPhone ? `tel:${lead.phone}` : undefined}
          onClick={() => hasPhone && track("lead_call_clicked", { lead_id: lead.id })}
          aria-disabled={!hasPhone}
          className={`${BUTTON} ${hasPhone ? "" : "pointer-events-none opacity-40"}`}
        >
          <Icon d={ICON.phone} />
          Call
        </a>
        <button type="button" data-attr="quick-action-book" onClick={onBook} className={BUTTON}>
          <Icon d={ICON.calendar} />
          Book
        </button>
        <button type="button" data-attr="quick-action-note" onClick={onAddNote} className={BUTTON}>
          <Icon d={ICON.note} />
          Add note
        </button>
      </div>
    </div>
  );
};

export default LeadActRow;
